// extracted by mini-css-extract-plugin
module.exports = {"dataGridWrapper":"actsAdmin_dataGridWrapper__1nxI5"};